export default function () {
    return {
        searchQuery: '',
    }
}
